import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["picker", "form"];

  showForm(event) {
    event.preventDefault();
    this.pickerTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
  }

  cancel(event) {
    event.preventDefault();
    this.formTarget.classList.add("hidden");
    this.pickerTarget.classList.remove("hidden");
  }
}
